import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'contact' | 'terms' | null;
const modalContent: Record<Exclude<ModalType, null>, {
  title: string;
  body: React.ReactNode;
}> = {
  privacy: {
    title: 'Política de Privacidad',
    body: <div className="space-y-4 text-botanical-forest/80 font-lora leading-relaxed" data-id="element-30">
        <p data-id="element-31">
          <strong data-id="element-32">Última actualización:</strong> Marzo 2026
        </p>
        <p data-id="element-33">
          En Piel de Seda, respetamos tu privacidad y nos comprometemos a
          proteger tus datos personales. Esta política describe cómo
          recopilamos, usamos y protegemos tu información.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-34">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-35">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, correo electrónico y datos de pago. No almacenamos
          información de tarjetas de crédito en nuestros servidores.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-36">
          2. Uso de la Información
        </h4>
        <p data-id="element-37">
          Tu información se utiliza exclusivamente para: procesar tu pedido,
          enviarte el acceso a tu guía digital, y comunicarte actualizaciones
          relevantes sobre tu compra.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-38">
          3. Protección de Datos
        </h4>
        <p data-id="element-39">
          Utilizamos encriptación SSL y medidas de seguridad estándar de la
          industria para proteger tu información personal durante la transmisión
          y el almacenamiento.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-40">
          4. Terceros
        </h4>
        <p data-id="element-41">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto los proveedores de pago necesarios para completar tu
          transacción.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-42">
          5. Contacto
        </h4>
        <p data-id="element-43">
          Si tienes preguntas sobre esta política, puedes escribirnos a:{' '}
          <span className="text-botanical-gold" data-id="element-44">vitalizanow@gmail.com</span>
        </p>
      </div>
  },
  contact: {
    title: 'Contacto',
    body: <div className="space-y-4 text-botanical-forest/80 font-lora leading-relaxed" data-id="element-45">
        <p data-id="element-46">
          Nos encanta escucharte. Si tienes preguntas sobre tu guía, necesitas
          soporte técnico o simplemente quieres compartir tu experiencia,
          estamos aquí para ti.
        </p>
        <div className="bg-botanical-ivory p-6 rounded-sm border border-botanical-sage/20 space-y-3 mt-6" data-id="element-47">
          <p data-id="element-48">
            <strong className="text-botanical-forest" data-id="element-49">
              Correo electrónico:
            </strong>
            <br data-id="element-50" />
            vitalizanow@gmail.com
          </p>
          <p data-id="element-51">
            <strong className="text-botanical-forest" data-id="element-52">
              Horario de atención:
            </strong>
            <br data-id="element-53" />
            Lunes a Viernes, 9:00 AM – 6:00 PM (hora CDMX)
          </p>
          <p data-id="element-54">
            <strong className="text-botanical-forest" data-id="element-55">
              Tiempo de respuesta:
            </strong>
            <br data-id="element-56" />
            Respondemos en un máximo de 24 horas hábiles.
          </p>
        </div>
        <p className="mt-6" data-id="element-57">
          Para soporte con tu descarga, por favor incluye el correo electrónico
          con el que realizaste tu compra.
        </p>
      </div>
  },
  terms: {
    title: 'Términos y Condiciones',
    body: <div className="space-y-4 text-botanical-forest/80 font-lora leading-relaxed" data-id="element-58">
        <p data-id="element-59">
          <strong data-id="element-60">Última actualización:</strong> Marzo 2026
        </p>
        <p data-id="element-61">
          Al adquirir la guía "Piel de Seda", aceptas los siguientes términos y
          condiciones de uso.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-62">
          1. Producto Digital
        </h4>
        <p data-id="element-63">
          "Piel de Seda" es un producto digital en formato PDF. Una vez
          completada la compra, recibirás acceso inmediato para descargar tu
          guía. No se realizan envíos físicos.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-64">
          2. Uso Personal
        </h4>
        <p data-id="element-65">
          La guía es para uso personal y no comercial. Queda prohibida su
          reproducción, distribución o reventa sin autorización expresa.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-66">
          3. Resultados
        </h4>
        <p data-id="element-67">
          Los resultados pueden variar según el tipo de piel, la constancia en
          la aplicación y los ingredientes utilizados. Las recetas están
          diseñadas con ingredientes naturales seguros, pero recomendamos
          realizar una prueba de sensibilidad antes de su uso.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-68">
          4. Política de Reembolso
        </h4>
        <p data-id="element-69">
          Debido a la naturaleza digital del producto, no se aceptan
          devoluciones una vez descargado. Si tienes problemas con el acceso,
          contáctanos y te ayudaremos de inmediato.
        </p>
        <h4 className="font-playfair text-botanical-forest text-lg mt-6" data-id="element-70">
          5. Modificaciones
        </h4>
        <p data-id="element-71">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las actualizaciones serán publicadas en esta misma página.
        </p>
      </div>
  }
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-botanical-forest-dark py-10 px-4" data-id="element-72">
        <div className="max-w-4xl mx-auto text-center" data-id="element-73">
          <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-74">
            <button onClick={() => setActiveModal('privacy')} className="text-botanical-ivory/60 hover:text-botanical-gold transition-colors duration-300 font-lora text-sm" data-id="element-75">
              Política de Privacidad
            </button>
            <span className="text-botanical-ivory/20 hidden sm:inline" data-id="element-76">·</span>
            <button onClick={() => setActiveModal('contact')} className="text-botanical-ivory/60 hover:text-botanical-gold transition-colors duration-300 font-lora text-sm" data-id="element-77">
              Contacto
            </button>
            <span className="text-botanical-ivory/20 hidden sm:inline" data-id="element-78">·</span>
            <button onClick={() => setActiveModal('terms')} className="text-botanical-ivory/60 hover:text-botanical-gold transition-colors duration-300 font-lora text-sm" data-id="element-79">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-botanical-ivory/40 font-lora text-sm" data-id="element-80">
            © {new Date().getFullYear()} vitalizateahora.com. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-81">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-botanical-forest-dark/60 backdrop-blur-sm" onClick={closeModal} data-id="element-82">
            <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="bg-white w-full max-w-2xl max-h-[80vh] rounded-sm shadow-2xl overflow-hidden flex flex-col" data-id="element-83">
              {/* Modal Header */}
              <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-botanical-sage/15 shrink-0" data-id="element-84">
                <h3 className="font-playfair text-xl md:text-2xl text-botanical-forest" data-id="element-85">
                  {modalContent[activeModal].title}
                </h3>
                <button onClick={closeModal} className="text-botanical-forest/40 hover:text-botanical-forest transition-colors duration-200 p-1" aria-label="Cerrar" data-id="element-86">
                  <X size={22} data-id="element-87" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="px-6 md:px-8 py-6 overflow-y-auto" data-id="element-88">
                {modalContent[activeModal].body}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}